function Button({ index, numQuestions, dispatch, answer }) {
  return (
    <>
      {answer !== null && (
        <button
          className="btn btn-action"
          onClick={() => {
            if (index < numQuestions - 1) dispatch({ type: "next" });
            else dispatch({ type: "finish" });
          }}
        >
          {index < numQuestions - 1 ? "Next" : "Result"}
        </button>
      )}
    </>
  );
}

export default Button;
